import type { ReactElement } from 'react';

import type {
  ContactsTierSelectProps,
  CurrencySelectProps,
  NonProfitToggleProps,
  PrepaySelectProps,
} from '@ctct/payflow-ui';
import { PricingConfiguratorContainer } from '@ctct/payflow-ui';

import type { usePricingConfiguratorWidget } from './usePricingConfiguratorWidget';
import './pricing-configurator-widget.scss';

export type PricingConfiguratorWidgetProps = ReturnType<typeof usePricingConfiguratorWidget> & {
  prepaySelectWidget: ReactElement<PrepaySelectProps> | null;
  contactsTierSelectWidget: ReactElement<ContactsTierSelectProps> | null;
  smsBundleTierSelectWidget?: ReactElement | null;
  currencyWidget: ReactElement<CurrencySelectProps> | null;
  nonProfitWidget: ReactElement<NonProfitToggleProps> | null;
  isSocialStarter?: boolean;
};

export const PricingConfiguratorWidget = ({
  data,
  prepaySelectWidget,
  contactsTierSelectWidget,
  smsBundleTierSelectWidget = null,
  currencyWidget,
  nonProfitWidget,
  isSocialStarter,
}: PricingConfiguratorWidgetProps) => {
  const labels = data.getLabels();

  return (
    <div className="pricing-configurator-widget">
      <PricingConfiguratorContainer
        heading={nonProfitWidget ? labels.heading : labels.headingPrepayOnly}
        nonProfitTooltip={labels.nonprofitTooltip}
        prepaySelect={prepaySelectWidget}
        contactsTierSelect={contactsTierSelectWidget}
        smsBundleTierSelect={smsBundleTierSelectWidget}
        currencySelect={currencyWidget}
        nonProfitToggle={nonProfitWidget}
        className={isSocialStarter ? 'social-starter' : undefined}
      />
    </div>
  );
};
